import React from 'react';
import { Eye, X } from 'lucide-react';
import { useImpersonation } from '@/contexts/ImpersonationContext';

export const ImpersonationBanner: React.FC = () => {
  const { impersonatedUser, isImpersonating, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <div
      className="sticky top-0 z-[9999] bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-md"
      dir="rtl"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="h-4 w-4" />
        <span>צופה כ: {impersonatedUser.displayName}</span>
      </div>
      <button
        onClick={stopImpersonation}
        className="flex items-center gap-1 bg-amber-600 hover:bg-amber-700 rounded px-3 py-1 text-sm font-medium transition-colors"
      >
        <X className="h-3 w-3" />
        יציאה
      </button>
    </div>
  );
};
